<template>
  <v-container class="bordered bg-white">
    <div class="grid_anual_parts">
      <CalcInputNumber
        class="input_area"
        :id="nodeId"
        field="annual_requirement_for_good_parts_part"
        :readonly="hasPartParent"
        :rules="[required, positive]" />
      <CalcInputNumber
        class="input_area"
        :id="nodeId"
        field="additional_annual_requirement_for_good_parts_part" />

      <CalcInputNumber
        class="input_area"
        :id="nodeId"
        field="numbers_of_lots_part"
        :rules="[required, positive, atLeastOne]" />

      <div>
        {{ $t("entities.part.fields.good_parts_per_lot_part") }}
      </div>

      <CalcOutput
        :id="nodeId"
        field="good_parts_per_lot_part"
        hide-label />
      <div>
        {{ $t("units.pc_per_lot") }}
      </div>

      <CalcInputNumber
        class="input_area"
        :id="nodeId"
        field="production_period_part"
        :rules="[required, positive]" />

      <div>
        {{
          $t("entities.part.fields.good_parts_over_the_production_period_part")
        }}
      </div>
      <CalcOutput
        :id="nodeId"
        field="good_parts_over_the_production_period_part"
        hide-label />

      <div class="e_per_piece_col_two_inputs">
        {{ $t("units.pcs") }}
      </div>
    </div>
  </v-container>
</template>

<script setup>
import { useTranslation } from "i18next-vue";
import { useCommonRules } from "@/validations/common";
import { computed } from "vue";
import { useSpaceStore } from "../../../../../stores/spaceStore";
import CalcOutput from "../../../../../components/Elements/CalcOutput.vue";
import CalcInputNumber from "@/components/Elements/CalcInputNumber.vue";

const { t } = useTranslation();
const { required, positive, atLeastOne } = useCommonRules(t);

const props = defineProps({
  nodeId: {
    type: String,
    required: true
  },
  variant: {
    type: Object,
    required: true
  }
});

const spaceStore = useSpaceStore();

const hasPartParent = computed(() => {
  return spaceStore.getElement(props.nodeId)?.parent.endsWith("part");
});
</script>

<style lang="scss">
.grid_anual_parts {
  font-size: 85%;
  display: grid;
  row-gap: 10px;
  column-gap: 20px;
  grid-template-columns: [start] 2fr 3fr 2fr [end];
  grid-area: "name output unit";
  align-items: center;

  .input_area {
    grid-column-start: start;
    grid-column-end: end;
  }
}
</style>
